import { createFileRoute } from "@tanstack/react-router";

import { Alerts } from "/src/routes/alerts";

export const Route = createFileRoute("/_main/")({
  component: Alerts,
});
